import { createFileRoute } from '@tanstack/react-router';

import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { OnboardingCheck } from '@/components/onboarding-check.component';
import { AppSumoUpgradePage } from '@/containers/appsumo-upgrade/appsumo-upgrade-page.component';
import {
  UPGRADE_PAGE_TITLE,
  validateAppSumoUpgradeSearch,
} from '@/lib/appsumo-upgrade';

/**
 * The AppSumo upgrade page (Oct 2026 campaign): Stripe's return from an
 * AppSumo checkout, and the move from Starter to Pro at the AppSumo price.
 * Every other visit, an email's link included, goes on to the plan wizard
 * with its plan preselected. No flag guard: the wizard sells the member
 * price on the server's answer alone, so the page Stripe sends that checkout
 * back to opens for the same browsers (PostHog blocked included). The
 * server gates the offer (404) and the checkout (403).
 */
export const Route = createFileRoute('/appsumo/upgrade')({
  validateSearch: validateAppSumoUpgradeSearch,
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  return (
    <>
      <Head heading={UPGRADE_PAGE_TITLE} />
      <AuthCheck>
        <OnboardingCheck>
          <AppLayout>
            <AppSumoUpgradePage search={search} />
          </AppLayout>
        </OnboardingCheck>
      </AuthCheck>
    </>
  );
}
